import { render, staticRenderFns } from "./VatReportSales.vue?vue&type=template&id=2c77ecee&"
import script from "./VatReportSales.vue?vue&type=script&lang=js&"
export * from "./VatReportSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports